import { FileInfo } from "./file-info";
import { UploadStatus } from '@enums/upload-status.enum';

export class FileUpload {
    file: File;
    progress: number;
    status: UploadStatus;
    fileInfo?: FileInfo;

    constructor(file: File) {
        this.file = file;
        this.progress = 0;
        this.status = UploadStatus.waiting;
        this.fileInfo = null;
    }
}
